import mutations from './mutations'
import actions from './actions'

const state = {
  myBookings: [],           
  myBookingsTotal: 0,      
  
  all_bookings: [],
  all_bookings_sum: {},
  bookings: [],
  booking: [],
  booking_detail: [],
  booking_more_detail: [],
  booking_payment: [],
  booking_details: null,
  deleted_bookings: [],
  confirmed_bookings: [],
  un_confirmed_bookings: [],
  checked_in_bookings: [],
  checked_out_bookings: [],
  activity_slots: 0,
  checking_in_today: [],
  checking_out_today: [],
  overstays_this_month: [],
  partner_bookings: [],
  all_partner_bookings: [],
  pending_partner_bookings: [],
  pending_group_bookings: [],
  inventory_schedule: [],
  facility_schedule: [],
  partner_checkin_today_bookings: [],
  partner_checkout_today_bookings: [],
  booking_tickets: [],
  booking_passes: [],
  batchfile_data: [],
  payment_gateways: [],
  gate_entry_report: [],
  volume: [],
  daily_report: [],
  bookings_inspection_report: [],
  volume_gtt: "",
  single_facility: {},
  booking_partner_name: "",
  payment_failure: {},
  current_day_bookings: {},
  inspection_bookings: [],
  inspection_booking: {},
  inspection_alerted_bookings: [],
  inspection_unticketed_alerted_bookings: [],
  booking_cost: {},
  all_bookings_report: [],
  booking_checkin: [],
  
  all_residency_proof: [],
  all_bookings_ban: [],
  booking_ban: [],


  puser_bookings: [],
  finanace_statement: [],
  booking_users: [],
  bank_slip: [],
  bankslip_data: [],
  booking_payment_failure: [],
  all_booking_payment: [],
  passport_verification: null,
  kenyan_id_verification: null,
  work_permit_verification: null,
  current_payment_search: {}
  
}

export default {
  state, 
  mutations, 
  actions
}